import { shouldNotForwardProps } from '@/shared/helpers';
import { styled } from '@mui/material';
import { getMainContentPaddingX } from './helpers';
export const MainContentHeadStyled = styled('div', shouldNotForwardProps('backdrop', 'headOnly', 'tight', 'loose', 'paddingX', 'paddingTop', 'paddingBottom'))(({ theme, paddingBottom, paddingX, tight, loose, headOnly }) => ({
    display: 'flex',
    flexDirection: 'column',
    paddingTop: theme.spacing(4),
    paddingBottom: paddingBottom ?? theme.spacing(2),
    paddingLeft: getMainContentPaddingX({ paddingX, tight, loose }),
    paddingRight: getMainContentPaddingX({ paddingX, tight, loose }),
    gap: theme.spacing(2),
    ...(headOnly &&
        paddingBottom === undefined && {
        paddingBottom: theme.spacing(6),
    }),
}));
